import type {SidebarLink} from '@github-ui/saved-views'
import {useAnalytics} from '@github-ui/use-analytics'
import {PlusIcon} from '@primer/octicons-react'
import {IconButton, NavList, Truncate} from '@primer/react'
import {useId} from 'react'

import {getHandlerNavItemClick} from '../utils/sidebar-link'
import styles from './ReposShortcutSidebar.module.css'
import {SidebarLinkIcon} from './SidebarLinkIcon'

interface ReposShortcutSidebarProps {
  shortcuts: SidebarLink[]
  onSelectLink: (linkItem: SidebarLink) => void
  selectedLink: string
  onCreateView: () => void
}

export function ReposShortcutSidebar({shortcuts, selectedLink, onSelectLink, onCreateView}: ReposShortcutSidebarProps) {
  const {sendAnalyticsEvent} = useAnalytics()
  const createViewButtonId = useId()

  return (
    <div>
      <div className={styles.headerRow} id={createViewButtonId}>
        <span className={styles.headerRowText}>Views</span>
        <IconButton icon={PlusIcon} size="small" variant="invisible" onClick={onCreateView} aria-label="Create view" />
      </div>
      <NavList aria-labelledby={createViewButtonId} className={styles.savedViewsList}>
        {shortcuts.map(linkItem => (
          <NavList.Item
            aria-current={selectedLink === linkItem.id && 'page'}
            key={linkItem.id}
            href={`?q=${linkItem.query}`}
            onClick={getHandlerNavItemClick({onSelectLink, sendAnalyticsEvent, linkItem})}
          >
            <NavList.LeadingVisual>
              <SidebarLinkIcon name={linkItem.icon} color={linkItem.color} />
            </NavList.LeadingVisual>
            <Truncate title={linkItem.name} maxWidth="100%">
              {linkItem.name}
            </Truncate>
          </NavList.Item>
        ))}
      </NavList>
    </div>
  )
}

try{ ReposShortcutSidebar.displayName ||= 'ReposShortcutSidebar' } catch {}